import { useSearchParams } from "react-router-dom";
import {
  PROPERTY_TRACK_TAB_OPTIONS,
  PropertyTrackTabOptions,
  Track,
} from "../types";
import useRenderPageComponent from "@/modules/common/hooks/render-page-component.hook";

import { useMemo } from "react";

export const usePropertyTrackTabs = ({
  track,
}: Partial<{ track: Track }> = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    handleTabURLChange(newValue);
  };

  const handleTabURLChange = (newValue: string | null) => {
    // for mobile tabs
    if (newValue === null) {
      setSearchParams((prevParams) => {
        prevParams.delete("tab");
        return prevParams;
      });
    } else if (
      PROPERTY_TRACK_TAB_OPTIONS.includes(newValue as PropertyTrackTabOptions)
    ) {
      setSearchParams({ tab: newValue }, { replace: true });
    } else {
      // default tab if providedtab is not valid
      setSearchParams(
        { tab: PROPERTY_TRACK_TAB_OPTIONS[0] },
        { replace: true }
      );
    }
  };

  const { renderedComponent: isConstructionTabVisible } =
    useRenderPageComponent({
      trackTypeId: track?.trackType.id,
      page: "property-details",
      component: "property-construction-tab",
    });

  const { renderedComponent: subPropertiesTabVisible } = useRenderPageComponent(
    {
      trackTypeId: track?.trackType.id,
      page: "property-details",
      component: "property-sub-properties-tab",
    }
  );
  const { renderedComponent: isRentalListingVisible } = useRenderPageComponent({
    trackTypeId: track?.trackType.id,
    page: "property-details",
    component: "property-listing-tab",
  });
  const { renderedComponent: isResaleListingVisible } = useRenderPageComponent({
    trackTypeId: track?.trackType.id,
    page: "property-details",
    component: "property-resale-listing-tab",
  });
  const { renderedComponent: isHospitalityListingVisible } =
    useRenderPageComponent({
      trackTypeId: track?.trackType.id,
      page: "property-details",
      component: "property-hospitality-listing-tab",
    });
  const { renderedComponent: isInterestsVisible } = useRenderPageComponent({
    trackTypeId: track?.trackType.id,
    page: "property-details",
    component: "property-interests-tab",
  });

  const { renderedComponent: isTenantsVisible } = useRenderPageComponent({
    trackTypeId: track?.trackType.id,
    page: "property-details",
    component: "property-tenants-tab",
  });

  const { renderedComponent: isDrawingProposalsVisible } =
    useRenderPageComponent({
      trackTypeId: track?.trackType.id,
      page: "property-details",
      component: "drawing-propsal-requests",
    });

  const selectedTab = useMemo(() => {
    const currentTab = searchParams.get("tab") as PropertyTrackTabOptions;
    if (currentTab)
      if (PROPERTY_TRACK_TAB_OPTIONS.includes(currentTab)) {
        return currentTab;
      } else {
        setSearchParams({ tab: PROPERTY_TRACK_TAB_OPTIONS[0] });
        return PROPERTY_TRACK_TAB_OPTIONS[0];
      }
    else return null;
  }, [searchParams, setSearchParams]);

  return {
    selectedTab,
    handleTabChange,
    handleTabURLChange,
    isConstructionTabVisible,
    subPropertiesTabVisible,
    isRentalListingVisible,
    isResaleListingVisible,
    isHospitalityListingVisible,
    isInterestsVisible,
    isTenantsVisible,
    isDrawingProposalsVisible,
  };
};
